import type { Chat } from "@circle-react/types/CommunityInbox/Chat";

import { useMessagingPaths } from "@/react/hooks/chatsV2/messaging/useMessagingPaths";

import { ChatItem } from "./BotChat/ChatItem";

interface BotChatItemProps {
  chat: Chat;
  isRenderedOnHeader?: boolean;
}

export const BotChatItem = ({ chat, isRenderedOnHeader }: BotChatItemProps) => {
  const { chatBotPath } = useMessagingPaths();
  return (
    <ChatItem
      key={chat.id}
      chat={chat}
      path={chatBotPath({ id: chat.id.toString() })}
      isUnread={chat.has_unread_messages_for_member}
      isRenderedOnHeader={isRenderedOnHeader}
      isBotType
      shouldHighlightChat
    />
  );
};
